'use client';

import { useTranslation } from 'next-i18next';
import { useAppSelector } from '@store/index';
import { getUserHeaderInfo } from '@store/reducers/userSelector';
import { PremiumDiscountBoxes } from '@components/features/cards/employer/PremiumDiscountBoxes';

interface ConsultantsInfoCardProps {
  accountDiscountData?: ApiSchema<'AccountDiscountData'>;
  isAuth:boolean,
}

export const OfferPremiumSection = ({
  accountDiscountData, isAuth,
}: ConsultantsInfoCardProps) => {
  // Translation (with namespace and locale if needed)
  const { t } = useTranslation('common');

  const headerInfo = useAppSelector(getUserHeaderInfo);

  return (
    <>
      <div className="bg-surface px-5 py-10 shadow-lg">
        {/* Title */}


        {headerInfo?.hasSubscription
          ? <h3 className="text-xl font-bold">{t('consultant.info.card.title.with.subscription')}</h3>
          : <h3 className="text-xl font-bold">{t('consultant.info.card.title')}</h3>}
        <div className="mb-10">
          {headerInfo?.hasSubscription
            ? t('consultant.info.card.benefits')
            : t('consultant.info.card.desc')}

        </div>

        <PremiumDiscountBoxes
          currentDiscountPercentage={accountDiscountData?.currentDiscountPercentage}
          isAuth={isAuth}
        />
      </div>
    </>
  );
};
